import * as React from 'react';

import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';

type Props = {
  color: string;
  width: string;
  height: string;
};

const ColorLineText: React.FC<Props> = (props) => {
  const useStyles = makeStyles((theme: Theme) =>
    createStyles({
      inputText: {
        width: props.width,
        height: props.height,
        background: props.color,
      },
    })
  );
  const classes = useStyles();
  return <input id="date" type="text" aria-readonly className={classes.inputText} readOnly />;
};
export default ColorLineText;
